import React, {
  useCallback, useEffect, useState,
} from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import keys from 'lodash/keys';

import fbAsync from '../../../services/facebook-async';
import { LoginAndPayForm } from './LoginAndPayForm';
import {
  ERROR_COLOR, FONT_FAMILY_MAIN, PALE_GREY, TEXT_COLOR,
} from '../../../theme';
import FBIcon from '../../../images/facebook-logo.inline.svg';
import stores from '../../../stores';

const FbLogin = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 32px;
  border-bottom: 1px solid ${PALE_GREY};
  position: relative;
  margin-bottom: 40px;
  flex-direction: column;

  &::after {
    content: 'OU';
    padding: 0 38px;
    background: #fff;
    font-family: ${FONT_FAMILY_MAIN};
    font-size: 14px;
    font-weight: bold;
    line-height: 1.29;
    letter-spacing: 1px;
    color: ${TEXT_COLOR};
    bottom: -9px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const FacebookBtn = styled.div`
  border-radius: 6px;
  background-color: ${(props) => (props.disabled ? PALE_GREY : '#3b5998')};;
  padding: 10px 24px 14px;
  color: #fff;
  display: flex;
  align-items: center;
  font-family: ${FONT_FAMILY_MAIN};
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
`;

const FacebookIcon = styled(FBIcon)`
  width: 32px;
  height: 32px;
  margin-right: 6px;

  #fb-icon-bg {
    fill: #fff;
  }
`;

const ErrorMessageContainer = styled.div`
  color: ${ERROR_COLOR};
  font-size: 14px;
  line-height: 1.17;
  margin-top: 10px;
`;

window.fbAsyncInit = function () {
  window.FB.init({
    appId: process.env.FACEBOOK_APP_ID,
    cookie: true,
    xfbml: false,
    version: 'v8.0',
  });
};

// Load the JavaScript SDK asynchronously
(function (d, s, id) {
  const fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  const js = d.createElement(s);
  js.id = id;
  js.src = '//connect.facebook.net/fr_FR/sdk.js';
  fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));

const ERROR_MESSAGES = {
  email: 'Ce champ est obligatoire.',
  dateNaissance: 'Ce champ est obligatoire.',
};

const FIELD_DISPLAY = {
  email: 'email',
  dateNaissance: 'Date de naissance',
};

const LoginOptions = ({ togglePaymentForm, cost, schoolId }) => {
  const [isLoggingIn, setLoggingIn] = useState(false);
  const [errors, setErrors] = useState({});
  const { userStore } = stores;
  useEffect(() => {
    const initFbLogin = async () => {
      setLoggingIn(true);
      try {
        const result = await fbAsync.getLoginStatus();
        if (result.status === 'connected') {
          const fbUser = await fbAsync.me();
          await userStore.signUpTheoryAccessStudentWithFb(schoolId, {
            access_token: result.authResponse.accessToken,
            facebook_id: fbUser.id,
            prenom: fbUser.first_name,
            nom: fbUser.last_name,
            dateNaissance: fbUser.birthday,
            email: fbUser.email,
          }, { setErrors });
        }
      } finally {
        setLoggingIn(false);
      }
    };
    // Timeout is required for FB init
    setTimeout(initFbLogin, 500);
  }, []);

  const onLogin = useCallback(async () => {
    setLoggingIn(true);
    try {
      const result = await fbAsync.login();
      if (result.status === 'connected') {
        const fbUser = await fbAsync.me();
        userStore.signUpTheoryAccessStudentWithFb(schoolId, {
          access_token: result.authResponse.accessToken,
          facebook_id: fbUser.id,
          prenom: fbUser.first_name,
          nom: fbUser.last_name,
          dateNaissance: fbUser.birthday,
          email: fbUser.email,
        }, { setErrors });
      }
    } finally {
      setLoggingIn(false);
    }
  }, []);
  return (
    <>
      {
        process.env.FACEBOOK_LOGIN_DISABLED !== 'true' && (
          <FbLogin>
            <FacebookBtn onClick={onLogin} disabled={isLoggingIn}>
              <FacebookIcon />
              Connexion avec Facebook
            </FacebookBtn>
            {keys(errors).map((field) => (
              <ErrorMessageContainer key={field}>
                {`${FIELD_DISPLAY[field]} - ${ERROR_MESSAGES[field]}`}
              </ErrorMessageContainer>
            ))}
          </FbLogin>
        )
      }
      <LoginAndPayForm togglePaymentForm={togglePaymentForm} cost={cost} schoolId={schoolId} />
    </>
  );
};

LoginOptions.propTypes = {
  schoolId: PropTypes.string.isRequired,
  togglePaymentForm: PropTypes.func.isRequired,
  cost: PropTypes.string.isRequired,
};

export { LoginOptions };
